// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2GyYT","notes":"Notes_notes__3JsLr"};